import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import {gql, Apollo} from 'apollo-angular';
import { AuthService } from 'src/app/auth/services/auth.service';
import { MustMatch } from 'src/app/_helpers/must-match.validator';
import { TranslateService } from '@ngx-translate/core';


const mutationSubmitDataStaff = gql`
mutation inputUserDetail($verificationToken:String!,$password:String!,$secondaryEmail:String){
  inputUserDetail(input: {
      verificationToken: $verificationToken
      userCredentialInputData: 
      {
          password: $password
          secondaryEmail : $secondaryEmail
      }
  })
}
`;

const mutationVerifyDataStaff = gql`
mutation verificationUser($verificationToken:String!){
  verificationUser(input: {
      verificationToken: $verificationToken
  })
}
`;


@Component({
  selector: 'app-verifystaff',
  templateUrl: './verifystaff.component.html',
  styleUrls: ['./verifystaff.component.scss']
})
export class VerifystaffComponent implements OnInit {
  verificationToken:any;
  btnloading:boolean=false;
  submitted = false;
  regID:string=''
  state:string='loading' // loading, expired, submitdata, success

  //model
  ValName:string=''
  ValPassword:string=''
  ValRetypePassword:string=''
  ValsecondaryEmail:string=''

  detailinfoForm = this.formBuilder.group({
    password: ['', Validators.required],
    retypepassword: ['', Validators.required],
    secondaryEmail: ['', [Validators.email, Validators.pattern("^(?!.{255})([a-zA-Z0-9.!#\$%&'*+\\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)\$")]],
  }
  , {
    validator: MustMatch('password', 'retypepassword')
  }
  );

  errortext:string=''

  constructor(
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private apollo: Apollo,
    private http:HttpClient,
    private router: Router,
    private authService: AuthService,
    public translate: TranslateService,
  ) { }

  ngOnInit(): void {
    this.authService.forceLogout();
    this.verificationToken = this.route.snapshot.paramMap.get('token');
    //this.pageloading=true;
    this.state = 'loading';

    if(this.verificationToken.length>32){
      this.state = 'submitdata'
    } else {
      this.router.navigate(['']);
    }

    this.checkVerificationUser()
  }

  checkVerificationUser(){
    var ArrData ={
      verificationToken: this.verificationToken,
    }
    this.apollo
    .mutate({
      mutation: mutationVerifyDataStaff,
      variables: ArrData
    })
    .subscribe(
      (res:any) => {
        console.log(res)
        if(res.data.verificationUser){
          // already registered, bypass create password
          this.state ='success'
        } else {
          // new user, input password and backup email
          this.state = 'submitdata'
        }
        
      },
      error => {
        console.log('error',error);
        var errMsg = error + '';
        var res = errMsg.split(":");
        var resMsg = res[res.length - 1];
        var msg = (resMsg)? resMsg: errMsg
        this.state ='expired'
        this.errortext = msg

        this.translate.get('error.VerificationTokenNotFound').subscribe((data:any)=> {
          if (this.translate.instant('error.VerificationTokenNotFound') !== 'error.VerificationTokenNotFound'){
            this.errortext = data
          }
        });

      }
    );

  }

  get f() { return this.detailinfoForm?.controls; }

  onSubmit() {
    this.submitted = true;
    console.log(this.detailinfoForm?.value);
    console.log(this.detailinfoForm);
    // stop here if form is invalid
    if (this.detailinfoForm.invalid) {
        return;
    }

    this.btnloading=true;

    let ArrData:any
    ArrData ={
      password: this.ValPassword
    }

    if(this.ValsecondaryEmail==''){
      ArrData ={
        verificationToken: this.verificationToken,
        password: this.ValPassword
      }
    } else {
      ArrData ={
        verificationToken: this.verificationToken,
        password: this.ValPassword,
        secondaryEmail: this.ValsecondaryEmail
      }
    }

    // this.state ='expired'
    // this.state ='success'
    // return

    this.apollo
    .mutate({
      mutation: mutationSubmitDataStaff,
      variables: ArrData
    })
    .subscribe(
      (res:any) => {
        console.log("succes, get data:", res);
        this.state ='success'
      },
      error => {
        console.log('error',error);
        var errMsg = error + '';
        var res = errMsg.split(":");
        var resMsg = res[res.length - 1];
        var msg = (resMsg)? resMsg: errMsg
        this.state ='expired'
        this.errortext = msg
      }
    );



  }
}
